import React from 'react';

class Contacto extends React.Component{
    render(){
        return (
              <React.Fragment>
                  <div className="Contact">
                          <div className="Info-contact">
                          <h1>Contacto</h1>
                          <h2>Email: james@devgrimaldo.com</h2>
                          <h2>Cel: +506 62329393</h2>
                          </div>
                  </div>
              </React.Fragment>
             
        ); 
    }
}

export default Contacto;